export enum Visibility {
    Public = 'public',
    Private = 'private',
}